document.addEventListener('DOMContentLoaded', ()=> {
  const contactForm = document.getElementById('contactForm');
  const chatCheckbox = document.getElementById('chat');
  const writeCheckbox = document.getElementById('write');
  const contactDataInput = document.getElementById('contactData');
  const consentCheckbox = document.getElementById('consent');
  const submitBtn = document.getElementById('submitBtn');
  const subscribeBtn = document.getElementById('subscribeBtn');
  const closeBtn = document.getElementById('button-close');
  const containerMessage = document.getElementById('msg-res');
  const titleMessage = document.querySelector('#msg-res .title');
  const textMessage = document.querySelector('#msg-res .text');
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneRegex = /^\+?(\d{1,3})?[-.\s]?(\(?\d{1,4}\)?)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
  const cookies = document.querySelectorAll('.cc-banner.cc-bottom')
  const cookiesMobile = document.querySelectorAll('.cc-window.cc-floating')

  const urlCollect = location.pathname.split('/')
  const brand = urlCollect[urlCollect.length - 1]
  const showMessage = (title = '¡Inscripción exitosa!') =>{
    contactDataInput.value = ''
    subscribeBtn.style.display = 'none';
    consentCheckbox.checked = false;
    containerMessage.style.display = 'flex';
    containerMessage.style.flexDirection = 'column';
    containerMessage.style.justifyContent = 'center';
    containerMessage.style.alignItems = 'center';

    titleMessage.textContent = title
    textMessage.textContent = 'Estaremos en contacto contigo, cuando la preventa inicie.'
    contactForm.style.display = 'none';
    setTimeout(() =>{
      containerMessage.style.display = 'none';
      subscribeBtn.style.display = 'block';
      closeBtn.style.display = 'none';
    }, 4000)
  }
  if(location.href.includes('?customer_posted=true')){
    showMessage()
  }else if(location.href.includes(`contact%5Btags%5D=coming-soon-${brand}&form_type=customer`)){
    const title = 'Ya estas suscrito.'
    showMessage(title)
  }
  if(location.pathname === '/pages/a-modo-mio'){
    setTimeout(() =>{
      const cookie = document.querySelector('body > div.cc-window.cc-banner.cc-type-info.cc-theme-block.cc-bottom.cc-color-override--560872518')
      const cookieMobile = document.querySelector('body > div.cc-window.cc-floating.cc-type-info.cc-theme-block.cc-bottom.cc-color-override--560872518')
      if(cookie) cookie.style.display = 'none'
      if(cookieMobile) cookieMobile.style.display = 'none'
    }, 2000)
    cookies.forEach((cookie) =>{
      cookie.style.display = 'none'
    })
    cookiesMobile.forEach((cookie) =>{
      cookie.style.display = 'none'
    })
  }
  const validateForm = () => {
    let valid = false
    if(chatCheckbox.checked){
      valid = phoneRegex.test(contactDataInput.value)
    }else{
      valid = emailRegex.test(contactDataInput.value)
    }
    if (consentCheckbox.checked && valid && (chatCheckbox.checked || writeCheckbox.checked)){
        submitBtn.disabled = false;
    } else {
        submitBtn.disabled = true;
    }
  }

  const updateInputType = () => {
    if (writeCheckbox.checked) {
      contactDataInput.type = 'email';
      contactDataInput.placeholder = 'Ingresa tu correo electrónico';
    } else if (chatCheckbox.checked) {
      contactDataInput.type = 'tel';
      contactDataInput.placeholder = 'Ingresa tu número de teléfono';
    } else {
      contactDataInput.type = 'text';
      contactDataInput.placeholder = 'Ingresa tu dato de contacto';
    }
  }

  subscribeBtn.addEventListener('click', () =>{
    contactForm.style.display = 'block';
    subscribeBtn.style.display = 'none';
    closeBtn.style.display = 'block';
  })
  closeBtn.addEventListener('click', () =>{
    contactForm.style.display = 'none';
    subscribeBtn.style.display = 'block';
    closeBtn.style.display = 'none';
    containerMessage.style.display = 'none';
  })
  contactDataInput.addEventListener('change', (e)=>{
    e.stopPropagation()
    validateForm()
  })
  chatCheckbox.addEventListener('change', (e) => {
    e.stopPropagation()

    if (chatCheckbox.checked) {
      writeCheckbox.checked = false;
    }
    updateInputType();
    validateForm()
  });

  writeCheckbox.addEventListener('change', (e) => {
    e.stopPropagation()

    if (writeCheckbox.checked) {
      chatCheckbox.checked = false;
    }
    updateInputType();
    validateForm()
  });

  const submitForm = (event) =>{
    event.preventDefault();
    event.stopPropagation()
    let valid = false
    if(chatCheckbox.checked){
      valid = phoneRegex.test(contactDataInput.value)
    }else{
      valid = emailRegex.test(contactDataInput.value)
    }
    if (consentCheckbox.checked && valid) {
      const contactMethod = chatCheckbox.checked ? 'Telefono' : 'Email';
      const contactData = contactDataInput.value;
      const data =[
        {
        'name': `${contactMethod}`,
        'value': `${contactData}` 
        },
        {
          'name': 'Tratamiento de datos',
          'value': 'Aceptado' 
        },
        {
          'name': 'Marca',
          'value': brand 
        }
      ]
      submitBtn.disabled = true;
      submitBtn.textContent = 'Enviando...'
      $.ajax({
        url: 'https://script.google.com/macros/s/AKfycbxeM8AD57m-2LxdiHi9ci0prMj_Lup1Zs7jdjENz6GGTyd6ItSownxW-fesap7LgUIV7A/exec',
        type: 'post',
        data: data,
        success: function(res){
          submitBtn.textContent = 'Enviar'
          if(!chatCheckbox.checked){
            const dataForm = new FormData();
            dataForm.append('form_type', 'customer');
            dataForm.append('contact[tags]', `coming-soon-${brand}`);
            dataForm.append('contact[note][AutorizoDatosPersonales]', `true`);
            dataForm.append('contact[email]', contactData);
  
            fetch('/contact', {
              method: 'POST',
              body: dataForm
            })
            .then(response => {
              console.log(response)
              const contentType = response.headers.get('content-type');
              if(response.url){
                location.href = response.url
              }
              if (contentType && contentType.includes('application/json')) {
                return response.json();
              } else {
                return response.text();
              }
            })
            .then(data => {
              console.log("");
            })
            .catch(error => console.error('Error:', error));
          }else{
            showMessage()
          }
        },
        error: function(){
          submitBtn.textContent = 'Enviar'
          contactDataInput.value = ''
          consentCheckbox.checked = false;

          containerMessage.style.display = 'flex';
          containerMessage.style.flexDirection = 'column';
          containerMessage.style.justifyContent = 'center';
          containerMessage.style.alignItems = 'center';

          titleMessage.textContent = '¡Inscripción fallida!'
          textMessage.textContent = 'Por favor inténtalo de nuevo.'
          contactForm.style.display = 'none';
          setTimeout(() =>{
            containerMessage.style.display = 'none';
            subscribeBtn.style.display = 'block';
            closeBtn.style.display = 'none';
          }, 4000)
        }
      });
    } else {
      console.log("");
    }
  }
  consentCheckbox.addEventListener('change', validateForm);
  contactForm.removeEventListener("submit", submitForm);
  contactForm.addEventListener('submit', submitForm)

  updateInputType();
  // validateForm();
});